import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async index(filter: string) {
    return useAsyncData('related-influencers', () =>
      this.call('/spa/research/instagram/related', { query: { filter } }),
    )
  }

  async loadMore() {
    await this.call('/spa/research/instagram/related/load-more', {
      method: 'post',
    })
  }

  async store(data: any) {
    await this.call('/spa/research/instagram/related', {
      method: 'post',
      body: data,
    })
  }

  async delete(id: number) {
    await this.call(`/spa/research/instagram/related/${id}`, {
      method: 'delete',
    })
  }

  async finish() {
    await this.call(`/spa/research/instagram/related/finish`, {
      method: 'post',
    })
  }
}
